<template>
  <base-container>
    <avue-crud
      ref="crud"
      :data="data"
      :table-loading="loading"
      :option="option"
      :page.sync="page"
      @search-change="searchChange"
      @search-reset="searchReset"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="refreshChange"
      @on-load="onLoad"
      @selection-change="selectionChange"
    >
      <template slot="menuLeft" slot-scope="{size}">
        <el-button type="primary" :size="size" @click="handleDoAuthBatch" >通过</el-button>
      </template>
      <template slot="tip"></template>
      <template slot="menu" slot-scope="scope">
        <el-button
          v-if="[2].includes(scope.row.authStatus)"
          type="text"
          size="small"
          plain
          class="none-border"
          @click.stop="handlePass(scope.row, scope.index)"
        >通过
        </el-button>
        <el-button
          v-if="[2].includes(scope.row.authStatus)"
          type="text"
          size="small"
          plain
          class="none-border"
          @click.stop="handleRefuse(scope.row, scope.index)"
        >拒绝
        </el-button>
      </template>

      <template slot="authStatus" slot-scope="{ row }">
        <el-tag>{{ getAuthStatus(row) }}</el-tag>
      </template>
      <template slot="idcardFront" slot-scope="{ row }">
          <image-preview :src="row.idcardFront" :width="100" :height="60"/>
      </template>
      <template slot="idcardBack" slot-scope="{ row }">
        <image-preview :src="row.idcardBack" :width="100" :height="60"/>
      </template>
    </avue-crud>
  </base-container>
</template>

<script>
import { searchAuthList, doAuth,doAuthBatch } from '@/api/user'
import { find } from 'ramda'
import { authStatusEnum, authTypeEnum } from './const'
export default {
  name: 'AuthList',
  data() {
    return {
      form: {},
      data: [],
      query: {},
      loading: false,
      recordIds:[],
      page: {
        pageSize: 20,
        currentPage: 1,
        total: 0
      },
      option: {
        addBtn: false,
        editBtn: false,
        delBtn: false,
        searchShow: true,
        columnBtn: false,
        searchBtnText: '查询',
        emptyBtnText: '重置',
        stripe: true,
        selection: true,
        selectable:(row,index)=>{
          return row.authStatus===2;
        },
        searchMenuSpan: 7,
        calcHeight: 350,
        tip: true,
        border: true,
        index: true,
        menuWidth: 100,
        searchSpan: 8,
        menu: this.checkMenuColumn,
        column: [
          {
            label: '昵称',
            prop: 'nickname',
            search: true,
            width: 150
          },
          {
            label: '手机号码',
            prop: 'mobile',
            search: true,
            width: 120
          },
          {
            label: '类型',
            prop: 'authType',
            searchValue: ' ',
            dicData: authTypeEnum,
            type: 'select',
            search: true,
            width: 120
          },
          {
            label: '状态',
            search: true,
            type: 'select',
            searchValue: ' ',
            dicData: authStatusEnum,
            prop: 'authStatus',
            slot: true,
            width: 120
          },
          {
            label: '姓名',
            prop: 'realname',
            width: 100
          },
          {
            label: '身份证号码',
            prop: 'idcard',
            width: 200
          },
          {
            label: '身份证正面',
            prop: 'idcardFront',
            type: 'img',
            width: 200
          },
          {
            label: '身份证背面',
            prop: 'idcardBack',
            searchSpan: 12,
            type: 'img',
            width: 150
          },
          {
            label: '申请时间',
            prop: 'applyTime',
            sortable: true,
            width: 150
          }
        ]
      }
    }
  },
  computed: {
    checkMenuColumn() {
      let columnShow = false
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].authStatus === 0 || this.data[i].authStatus === 2) {
          columnShow = true
          break
        }
      }
      return columnShow
    }
  },
  methods: {
    selectionChange(list){
      this.recordIds = []
      for (let i = 0; i < list.length; i++) {
        this.recordIds.push(list[i].id)
      }
      console.log(this.recordIds)
    },
    tagColor(row) {
      return find((item) => item.value === row.authStatus)(authStatusEnum).tag
    },
    getAuthStatus(row) {
      return find((item) => item.value === row.authStatus)(authStatusEnum).label
    },
    searchReset() {
      this.query = {}
      this.onLoad(this.page)
    },
    searchChange(params, done) {
      this.query = params
      this.page.currentPage = 1
      this.onLoad(this.page, params)
      done()
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize
    },
    refreshChange() {
      this.onLoad(this.page, this.query)
    },
    handleDoAuthBatch(){
      if (this.recordIds.length==0){
        return
      }
      this.$confirm('确定要通过该视频审核么？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let ids = "";
          this.recordIds.forEach(function (id) {
            ids += id + ",";
          });
          ids = ids.substring(0, ids.length - 1);
          doAuthBatch(ids).then(() => {
            this.$message({
              type: 'success',
              message: '操作成功'
            }, this.onLoad(this.page))
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    handlePass(row) {
      const { id, mobile ,userId} = row
      this.$confirm('确定要通过该视频审核么？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          doAuth({ recordId: id, mobile, opt: 1,userId:userId }).then(() => {
            this.$message({
              type: 'success',
              message: '操作成功'
            }, this.onLoad(this.page))
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    handleRefuse(row) {
      const { id, mobile } = row
      this.$confirm('确定要拒绝该视频审核么？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          doAuth({ recordId: id, mobile, opt: 0 }).then(() => {
            this.$message({
              type: 'success',
              message: '操作成功'
            }, this.onLoad())
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    onLoad(page, params = {}) {
      this.recordIds =[]
      this.loading = true
      searchAuthList(page.currentPage, page.pageSize, params)
        .then((res) => {
          console.log(res)
          this.page.total = res.total
          this.data = res.data
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style>
.none-border {
  border: 0;
  background-color: transparent !important;
}
.el-icon-circle-close {
  color: "#fff";
}
</style>
